import { Button, Dialog, ExclamationTriangleIcon, Flex, Link, Text } from 'components'
import { useState } from 'react'
import { BaseUrl, forceDark, sendIntercomMessage } from 'utils'
import { useCurrentUser, useWorkspace } from './providers'

export default function InactiveSubscriptionBanner() {
  const user = useCurrentUser()
  const { workspace } = useWorkspace()
  const [open, setOpen] = useState(false)

  if (!user || !workspace?.id || workspace?.status.value !== 'inactive') return null

  return (
    <Flex
      alignItems="center"
      backgroundColor="danger.600"
      gap={2}
      justifyContent="space-between"
      px={{ base: 4, md: 6 }}
      py={2}
      {...forceDark}
    >
      <Flex alignItems="center" gap={2}>
        <ExclamationTriangleIcon />
        <Text userSelect="none" textStyle="h6">
          Inactive Momentify Subscription
        </Text>
      </Flex>
      <Button backgroundColor="white" color="black" onClick={() => setOpen(true)} size="sm">
        Help
      </Button>

      <Dialog
        open={open}
        title={
          <Flex align="center" gap={2}>
            <ExclamationTriangleIcon fill="danger.600" size="lg" />
            Workspace subscription inactive
          </Flex>
        }
        onClose={() => setOpen(false)}
        placement="center"
        bodyProps={{ p: 6 }}
        contentProps={{ maxW: 'lg' }}
        footer={
          <Button
            variant="outline"
            onClick={() =>
              sendIntercomMessage(
                `Hello, I need help reactivating my subscription for workspace "${workspace?.title || ''}".`
              )
            }
          >
            Contact Momentify Team
          </Button>
        }
      >
        <Flex direction="column" gap={3} p={1} pt={2}>
          <Text textStyle="bodyMedium">
            Your workspace is currently <b>inactive</b>, so creation and update actions are
            disabled.
          </Text>
          <Text textStyle="bodyMedium">Please contact a Momentify admin to reactivate.</Text>
          <Link href={`${BaseUrl.root}/contact`} target="_blank" color="blue.500">
            momentifyapp.com/contact
          </Link>
        </Flex>
      </Dialog>
    </Flex>
  )
}
